/**
 * Flag that indicates whether or not the data of the Insights app may be dirty
 * and thus whether or not a hard reload is required when on the Insights app.
 */
let insightsDataDirtyFlag = false;

/**
 * Get the flag that indicates whether or not the data of the Insights app may be dirty
 * and thus whether or not a hard reload is required when on the Insights app.
 */
export const getInsightsDataDirtyFlag = (): boolean => insightsDataDirtyFlag;

/**
 * Trip the flag, indicating that the data of the Insights app may be dirty
 * and thus a hard reload is required when on the Insights app.
 */
export const tripInsightsDataDirtyFlag = (): void => {
  insightsDataDirtyFlag = true;
};
